import { COMMON } from "@store/theme/common/design";

const maxWidth = COMMON.breakpoints[COMMON.breakpoints.length - 1];

export default {
    values: COMMON.breakpoints,
    maxWidths: COMMON.breakpoints.map(x => maxWidth),
};
